import { AddCircleOutline, Search } from '@mui/icons-material'
import { Box, InputAdornment, styled, useTheme } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useGetEquipmentInStorage, useGetStorageById } from 'src/api/storage'
import { AppTextField } from 'src/components/AppTextField'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import StoredEquipmentTable from 'src/containers/storage/StoredEquipmentTable'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { MUIThemeColors } from 'src/mui-theme'
import { CreateMainComponentDialog } from 'src/screens/customer/mainComponents/CreateMainComponentDialog'
import { StyledSearchField } from 'src/screens/customer/users/UsersContainer'
import { getThemeColor } from 'src/utils'
const Dashboard = () => {
  const { customerId, storageId } = useParams()
  const [search, setSearch] = useState('')
  const { data, isLoading } = useGetStorageById(customerId as EntityId, storageId as EntityId)
  const { data: equipments, isLoading: isEquipmentLoading } = useGetEquipmentInStorage(
    customerId as EntityId,
    storageId as EntityId,
    search,
  )
  const theme = useTheme()
  const { t } = useTranslation('storage')

  const { showDialog } = useDialogCtx()
  const onAdd = async () => {
    const added = await showDialog(
      CreateMainComponentDialog,
      {
        componentProps: {
          customerId: customerId as EntityId,
          storageId: storageId as EntityId,
        },
        isAutoCloseDisabled: true,
      },
      undefined,
      true,
    )
    if (!added) return
  }
  return (
    <div>
      <CommonPageLayout titleSection={{ title: `${t('storage')} : ${data?.name} ` }}>
        <CommonPageLayout
          titleSection={{ subtitle: t('equipment') }}
          topAction={[
            <StyledSelectBox key={'search'}>
              <AppTextField
                label={t('search', { ns: 'common' })}
                placeholder={t('search', { ns: 'common' })}
                fullWidth
                sx={{ minWidth: '200px' }}
                onChange={evt => setSearch(evt.target.value)}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </StyledSelectBox>,
            {
              buttonText: 'equipment',
              buttonIcon: <AddCircleOutline />,
              onClick: onAdd,

              variant: 'outlined',
              shadowWeight: null,
            },
          ]}
        >
          <Box padding={'8px'} bgcolor={getThemeColor(theme, MUIThemeColors.white)} borderRadius={'4px'}>
            <StoredEquipmentTable
              data={equipments}
              isLoading={isEquipmentLoading}
              customerId={customerId as EntityId}
              storageId={storageId as EntityId}
            />
          </Box>
        </CommonPageLayout>
      </CommonPageLayout>
    </div>
  )
}

export default Dashboard

const StyledSelectBox = styled(StyledSearchField)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${theme.palette.secondaryLight[theme.palette.mode]}`,
  },
}))
